var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.08911,
    cy: 8,
    r: 8,
    fill: "#E60012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61097 10.7081L6.61179 10.7072L4.38849 8.21508C4.31343 8.1281 4.27186 8.01156 4.27272 7.89055C4.27358 7.76955 4.31681 7.65376 4.39309 7.56814C4.46937 7.48251 4.57261 7.43389 4.68056 7.43276C4.78852 7.43162 4.89255 7.47806 4.97025 7.56206L7.19356 10.0546L11.5607 5.16042C11.5987 5.11634 11.6441 5.08119 11.6944 5.057C11.7446 5.03281 11.7986 5.02008 11.8533 5.01955C11.908 5.01902 11.9622 5.03069 12.0128 5.0539C12.0634 5.0771 12.1093 5.11137 12.148 5.1547C12.1867 5.19803 12.2172 5.24956 12.2379 5.30628C12.2586 5.36299 12.269 5.42376 12.2686 5.48504C12.2681 5.54632 12.2567 5.60688 12.2352 5.66318C12.2136 5.71949 12.1822 5.77041 12.1429 5.81298L7.48424 11.0344C7.40703 11.1209 7.30232 11.1695 7.19315 11.1695C7.08397 11.1695 6.97927 11.1209 6.90206 11.0344L6.61097 10.7081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.867e8318d3bfee15620ae3c7142f95a6.svg";
export { ForwardRef as ReactComponent };